import globalCorporatePartner from './modules/globalCorporatePartner';
import hotelsResults from './modules/hotelsResults';

export default {
  init() {
  },
  finalize() {
    globalCorporatePartner();
    hotelsResults();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalCorporatePartner.js